import { render, staticRenderFns } from "./pos_settings_modal.vue?vue&type=template&id=530731d5&scoped=true&"
import script from "./pos_settings_modal.vue?vue&type=script&lang=js&"
export * from "./pos_settings_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530731d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530731d5')) {
      api.createRecord('530731d5', component.options)
    } else {
      api.reload('530731d5', component.options)
    }
    module.hot.accept("./pos_settings_modal.vue?vue&type=template&id=530731d5&scoped=true&", function () {
      api.rerender('530731d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_settings/pos_settings_modal.vue"
export default component.exports